import type { AIResponse, Message } from "../utils/types";
import type { AttachmentMetaData } from "src/app/Task/Attachments/Attachment";
import type { WsMemberSelectedContext } from "src/redux/ai-chat/aiChatTypes";
import { formatTimestamp, formatTime } from "../utils/formatTimestamp";

export function createUserMessage(
  content: string,
  attachedFiles?: AttachmentMetaData[],
  selectedItems?: WsMemberSelectedContext,
): AIResponse {
  return {
    id: Date.now().toString(),
    role: "user",
    content,
    timestamp: formatTimestamp(),
    ...(attachedFiles && attachedFiles.length ? { attachedFiles } : {}),
    ...(selectedItems ? { selectedItems } : {}),
  };
}

export function createAssistantPlaceholder(): AIResponse {
  return {
    id: (Date.now() + 1).toString(),
    role: "assistant",
    content: "",
    isStreaming: true,
    timestamp: formatTimestamp(),
  };
}

export function mapHistoricMessages(msgs: Message[]): AIResponse[] {
  const result: AIResponse[] = [];

  for (let i = 0; i < msgs.length; i++) {
    const msg = msgs[i];
    const role: "user" | "assistant" =
      msg.message_type === 0 ? "user" : "assistant";
    const timestamp = formatTime(new Date(msg.created_at * 1000));

    result.push({
      id: msg.id.toString(),
      role,
      content: msg.content,
      timestamp,
    });
  }

  return result;
}
